import React from 'react';

import AddressEdit from '../lane/AddressEdit';

export default function AddressInput({ value, onChange }: any) {
  return <AddressEdit address={value} onAddressUpdated={onChange} />;
}
